import React from 'react';
import { Header } from '../../../components/ToxicDetector/Header';
import { HeroSection } from '../../../components/ToxicDetector/HeroSection';
import { TrustSection } from '../../../components/ToxicDetector/TrustSection';
import { FeaturesSection } from '../../../components/ToxicDetector/FeaturesSection';
import { GuaranteesSection } from '../../../components/ToxicDetector/GuaranteesSection';
import { ToolsSection } from '../../../components/ToxicDetector/ToolsSection';
import { ComparisonSection } from '../../../components/ToxicDetector/ComparisonSection';
import { PricingSection } from '../../../components/ToxicDetector/PricingSection';
import { FAQSection } from '../../../components/ToxicDetector/FAQSection';
import { CTASection } from '../../../components/ToxicDetector/CTASection';
import { Footer } from '../../../components/ToxicDetector/Footer';
import { MetaTags } from '../../../components/SEO/MetaTags';
import { PromoBanner } from '../../../components/Notifications/PromoBanner';
import { GoogleTranslateWidget } from '../../../components/GoogleTranslateWidget';
export function LandingPageID() {
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/'
  }];
  return <>
      <MetaTags title="ToxicDetector: Analisis Hubungan AI | Deteksi Pola Beracun & Gaslighting" description="Cari tahu apakah mantan Anda masalahnya. Unggah obrolan Anda ke AI ToxicDetector untuk analisis instan dan rahasia tentang manipulasi, gaslighting, dan bendera merah. Mulai pemindaian gratis hari ini." keywords="analisis hubungan AI, deteksi pola beracun, detektor gaslighting, mantan beracun, pemeriksa manipulasi, toksisitas hubungan, pemindai teks AI" canonical="https://toxicdetector.com/id" language="id" alternateUrls={alternateUrls} data-id="element-7035" data-mp="23kjjrvsex66b" />
      <GoogleTranslateWidget data-id="element-7036" data-mp="39as84iqp2teu" />
      <PromoBanner data-id="element-7037" data-mp="3eb6hc44189eg" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-7038" data-mp="3ebpqavbpfngc">
        <Header data-id="element-7039" data-mp="30byf12ckol61" />
        <main data-id="element-7040" data-mp="30cgjundaw7pk">
          <HeroSection h1Override={<>
                Otak Anda{' '}
                <span className="relative inline-block" data-id="element-7042" data-mp="35b1lmr87azg4">
                  <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-b from-gray-200 to-gray-500" data-id="element-7043" data-mp="yjinwio88z0e">
                    Berbohong
                  </span>
                  <span className="absolute top-1/2 left-0 w-full h-[4px] md:h-[6px] bg-[#FF0000] -translate-y-1/2 rotate-[-2deg]" data-id="element-7044" data-mp="1dn3alw15s1rd" />
                </span>{' '}
                Kepada Anda.
                <br data-id="element-7045" data-mp="18m5sfjg5f7pv" />
                <span className="text-[#FF0000] drop-shadow-[0_0_30px_rgba(255,0,0,0.4)]" data-id="element-7046" data-mp="1mf59hpvkx9zj">
                  AI Kami Tidak.
                </span>
              </>} data-id="element-7041" data-mp="30czsfdh29jqx" />
          <TrustSection data-id="element-7047" data-mp="1wdl0lsulwj91" />
          <FeaturesSection data-id="element-7048" data-mp="1wd1pow3div4i" />
          <GuaranteesSection data-id="element-7049" data-mp="1wc9zy1wgjrm5" />
          <ToolsSection data-id="element-7050" data-mp="1wfe8tckvbbj5" />
          <ComparisonSection data-id="element-7051" data-mp="1reqg8mgzqmmt" />
          <PricingSection data-id="element-7052" data-mp="1rdov1p69gjrd" />
          <FAQSection data-id="element-7053" data-mp="1re8amz8fuw28" />
          <CTASection data-id="element-7054" data-mp="25e9d2j4cqbjt" />
        </main>
        <Footer data-id="element-7055" data-mp="25d81mdjfbn1k" />
      </div>
    </>;
}